<template>
  <div class="main">
    <div class="top-title">
      <div>
        <van-icon name="wechat" color="#FFFFFF" size="20"/>
        <a class="title-text">{{title}}</a>
      </div>
      <div class="top-actions">
        <van-button v-if="form.Role === 'passenger' && form.DriverId" size="mini" round @click="cancleBind">取消绑定</van-button>
        <van-button size="mini" round @click="reregister">重新注册</van-button>
      </div>
    </div>
    <div style="margin: -80px 12px 12px 12px;line-height: 1.5;">
      <div class="card">
        <div class="cell-flex">
          <div style="font-size: 16px;font-weight: 600;">每日提醒</div>
          <div v-if="needBind" class="cell-flex card-msg" @click="goTo('audit')">
            <van-icon name="send-gift" color="#F22222" size="18"/>
            <div style="margin: 0 4px;">你有新的拼车请求!</div>
            <van-icon name="arrow" style="margin-left: 20px;"/>
          </div>
        </div>
        <div style="margin-top: 10px;">
          <template v-if="form.Status">
            <div class="driver-time" @click="showDate = !driverBtn">
              <div class="cell-flex">
                <a style="width: 50px;">{{form.Role === 'driver' ? '出发' : '上车'}}</a>
                <a style="font-size: 14px;">{{time}}</a>
                <a style="color: #999999;font-size: 14px;margin-left: 6px;">( {{date}}  {{week}} )</a>
              </div>
              <van-icon v-show="!driverBtn" name="arrow" color="#D2D2D2"/>
            </div>
            <van-calendar
              v-model="showDate"
              :default-date="null"
              color="#FEB013"
              safe-area-inset-bottom
              :min-date="minDate"
              :max-date="maxDate"
              @select="onCalendarSelect">
              <div slot="footer" class="calendar-footer">
                <div>日期：{{date}} 时间：{{time}}</div>
              </div>
            </van-calendar>
            <van-popup v-model="showTime" position="bottom">
              <van-datetime-picker
                v-model="time"
                type="time"
                :min-hour="6"
                :max-hour="8"
                @confirm="onTime"
                @cancel="showTime = false"
              />
            </van-popup>
            <div class="driver-way">
              <a style="display: table;width: 50px;">{{form.Role === 'driver' ? '途径' : '地点'}}</a>
              <div style="font-size: 14px;">{{form.Way}}</div>
            </div>
            <template v-if="form.Role === 'driver'">
              <template v-if="driverBtn">
                <van-row gutter="20">
                  <van-col span="12">
                    <van-button block plain round @click="driverCancle">取消发车</van-button>
                  </van-col>
                  <van-col span="12">
                    <van-button block round color="#333333" @click="checkDriver">确认发车</van-button>
                  </van-col>
                </van-row>
              </template>
              <template v-else>
                <van-button block round color="#FEB013" :disabled="driverBtn" @click="onMake">发起预约拼车</van-button>
              </template>
            </template>
            <template v-else>
              <div class="driver-info driver-card">
                <div class="cell-flex">
                  <van-image round width="34px" height="34px" :src="form.DriverAvatar" />
                  <div style="padding-left: 12px;">
                    <div>{{form.DriverName}} {{form.DriverCarNum}}</div>
                    <div>
                      <a>({{form.DriverCarName}} | {{form.DriverCarSeat}}座)</a>
                    </div>
                  </div>
                </div>
                <a style="text-align: center;color: black;" :href="'tel://' + form.DriverPhone">
                  <van-icon name="phone" color="#FEB013" size="24"/>
                  <div>联系司机</div>
                </a>
              </div>
              <template v-if="havingTravel && passengerTravelStatus === '已拼车'">
                <van-row gutter="20">
                  <van-col span="12">
                    <van-button block plain round :disabled="passengerBtn" @click="passengerCancle">取消拼车</van-button>
                  </van-col>
                  <van-col span="12">
                    <van-button block round color="#333333" :disabled="passengerBtn" @click="passengerConfirm">确认上车</van-button>
                  </van-col>
                </van-row>              
              </template>
              <template v-else-if="havingTravel && passengerTravelStatus === '已上车'">
                <van-button block round color="#999999" disabled>已完成</van-button>
              </template>
              <template v-else>
                <!-- <van-button block round color="#FEB013" :disabled="passengerBtn" @click="onBoard">{{passengerBtnText}}</van-button> -->
                <van-button block round color="#FEB013" :disabled="passengerBtn" @click="passengerConfirm">{{passengerBtnText}}</van-button>
              </template>
            </template>
            <div class="driver-text" v-if="form.Role === 'driver'">每日发起拼车后，绑定的乘客将收到你的预约</div>
            <div class="driver-text" v-else>司机发起拼车后，你将收到司机的预约</div>
          </template>
          <template v-else>
            <div class="cell-flex-center">
              <div>
                <van-image width="80" :src="require('../../assets/none.svg')"/>
                <div style="font-size: 12px;">暂无数据~</div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <template v-if="form.Role === 'driver'">
        <div v-if="passengerList.length > 0" style="font-size: 14px;">以下是已绑定的乘客列表</div>
        <div v-for="(item, key) in passengerList" :key="key" class="passenger">
          <div class="cell-flex">
            <van-image round width="30px" height="30px" :src="item.Avatar" />
            <div style="margin-left: 10px;">
              <div style="font-weight: 600;"><van-icon name="location" size="15" color="#999999"/>{{item.Way}}</div>
              <div class="cell-flex">
                <div style="min-width: 45px;">{{item.Name}}</div>
                <div
                  v-if="item.TravelStatus"
                  class="passenger-status"
                  :style="item.TravelStatus === '已拼车' ? 'background-color:#39A0F4;' : 'background-color:#F22222;'"
                >{{item.TravelStatus}}</div>
              </div>
            </div>
          </div>
          <a style="text-align: center;color: #333333;" :href="'tel://' + item.Phone">
            <van-icon name="phone" size="25" color="#FEB013"/>
            <div style="font-size: 12px;">联系乘客</div>
          </a>
        </div>
      </template>
      <template v-else>
        <div style="font-size: 14px;">以下仅附近站点区域内的早拼推荐</div>
        <van-sticky>
          <van-search v-model="searchValue" background="#F5F5F5" placeholder="输入 站点或司机姓名 查询" @input="getDriverList"/>
        </van-sticky>
        <div v-for="(item, key) in driverList" :key="key" class="driver-list">
          <div class="driver-info">
            <div class="cell-flex">
              <van-image round width="34px" height="34px" :src="item.Avatar" />
              <div style="padding-left: 12px;">
                <div>{{item.Name}} {{item.CarNum}}</div>
                <div>
                  <a>({{item.CarName}} | {{item.CarSeat}}座)</a>
                  <a style="padding-left: 8px;color: red;">已拼{{item.passengers.length}}人</a>
                </div>
              </div>
            </div>
            <van-button :disabled="bindBtn" icon="coupon" round color="#333333" @click="goTo('bind', item.UserId)"> 绑 定 </van-button>
          </div>
          <div class="cell-flex driver-bottom">
            <van-icon name="location" color="#4DBE86"/>
            <div style="padding-left: 12px;">{{item.Way}}</div>
          </div>
        </div>
      </template>
    </div>
      <div style="height: 5px;"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        WXInfo: {},
        title: '',
        form: {},
        passengerList: [],
        driverList: [],
        showDate: false,
        showTime: false,
        minDate: new Date(),
        maxDate: this.$moment(new Date()).add(1,'days')._d,
        time: '00:00',
        date: '0000-00-00',
        week: this.$moment(new Date()).format('dddd'),
        needBind: false,
        bindBtn: false,
        driverBtn: true,
        passengerBtn: false,
        havingTravel: false,
        searchValue: '',
        passengerBtnText: '',
        passengerTravelStatus: null,
        boardPerson: []
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"area":"健树","errcode":0,"errmsg":"ok","userid":"201755100","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.form.Name = this.WXInfo.name
    this.form.UserId = this.WXInfo.userid
    this.form.Phone = this.WXInfo.mobile
    this.getData()
  },
  methods: {
    async getData () {
      await this.getUserInfo()
      if (this.form.Role === 'driver') {
        this.time = this.form.DepartTime
        if (this.form.Status && this.form.passengers.length) {
          this.title = '绑定生效中...'
        } else if (this.form.Status && !this.form.passengers.length) {
          this.title = '绑定生效中，等待乘客拼车...'
        } else if (!this.form.status && !this.form.Effictive) {
          this.title = '审核被拒绝，请联系王海苑'
        } else {
          this.title = '正在审核中，请耐心等待'
        }
        this.getPassengerList().then(val => {
          this.passengerList = val.data
          this.getWorkTravelApi(this.form.UserId)
        })
        this.getNeedBindData()
        // await this.getWorkTravelApi(this.form.UserId)
      } else {
        if (this.form.DriverId && !this.form.Effictive) {
          this.bindBtn = true
          this.title = '等待司机确认...'
        } else if (this.form.DriverId && this.form.Effictive && !this.form.Status) {
          this.bindBtn = true
          this.title = '等待后台审核确认...'
        } else if (this.form.Effictive && this.form.Status) {
          this.bindBtn = true
          this.driverBtn = true
          this.title = '绑定生效中...'
          this.time = this.form.DepartTime
          this.getTravel(this.form.DriverId)
        } else {
          this.bindBtn = false
          this.title = '请选择合适的路线绑定'
        }
        this.getDriverList()
      }
    },
    // 司机发起预约行程
    async onMake() {
      if (this.date !== '0000-00-00') {
        if (this.passengerList.length) {
          let arr = this.form.Way.split(',')
          let data = {
            UserId: this.form.UserId,
            Origin: arr[0],
            Destination: '公司',
            Way: this.form.Way,
            LngLat: this.form.LngLat,
            DateTime: this.date,
            DepartTime: this.time,
            Status: '已发布'
          }
          const result = await this.postWorkTravel(data)
          if (result.success) {
            this.$toast('行程发布成功')
            this.getWorkTravelApi(this.form.UserId)
            this.passengerList.forEach(item => {
              this.sendMessage('driverMake', item.UserId, item)
            })
          } else {
            this.$toast(result.message)
          }
        } else {
          this.$toast('当前没有绑定乘客，无法发起拼车。')
        }
      } else {
        this.$toast('请选择发车时间！')
      }
    },
    // 司机取消行程
    driverCancle() {
      this.$dialog.confirm({
        title: '提示',
        message: '是否取消行程？',
      })
        .then(async () => {
          const result = await this.deleteTravel(this.travelId)
          this.$toast(result.message)
          if (result.success) {
            this.driverBtn = false
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    // 校验是否可以发车
    checkDriver() {
      let nowDate = this.$moment(new Date()).format('YYYY-MM-DD')
      if (nowDate === this.date) {
        this.getWorkTravelFromPassenger({ParentsId: this.travelId}).then(val => {
          let list = val.data
          if (list.length) {
            this.refreshPassengerStatus(list)
            let data = list.filter(item => item.Status === '已拼车')
            if (data.length) {
              this.driverConfirm()
            } else {
              this.driverPostTravel()
            }
          } else {
            this.$toast('当前没有乘客拼车，无法发车。')
          }
        })
      } else {
        this.$dialog.alert({
          title: '提示',
          message: '当前 '+ this.$moment(new Date()).format('YYYY-MM-DD HH:mm') +' 时间，在非有效时间内，无法确认发车。'
        })
      }
    },
    // 司机确认发车
    driverConfirm() {
      this.$dialog.confirm({
        title: '提示',
        message: '系统检查到还有乘客没有上车，是否确认发车？',
      }).then(() => {
        this.driverPostTravel()
      }).catch(() => {
        console.log('取消')
      })
    },
    async driverPostTravel() {
      let data = { Status: '已发车' }
      const result = await this.postWorkTravel(data)
      if (result.success) {
        this.driverBtn = false
        this.$dialog.alert({ title: '提示', message: '今日拼车已完成~' })
        this.boardPerson.forEach(item => {
          this.sendMessage('driverConfirm', item.UserId, item)
        })
        this.passengerList.forEach(item => { this.$set(item, 'TravelStatus', '') })
      } else {
        this.$toast(result.message)
      }
    },
    // 司机刷新乘客状态
    refreshPassengerStatus(data) {
      data.forEach(ele => {
        this.passengerList.forEach(item => {
          if (ele.UserId === item.UserId) {
            this.$set(item, 'TravelStatus', ele.Status)
          }
        })
      })
    },
    // 乘客获取所有司机路线
    async getDriverList () {
      let query = {
        Role: 'driver',
        Effictive: true,
        Status: true
      }
      const kw = (this.searchValue || '').trim()
      if (kw) {
        query.keyword = kw
      }
      const result = await this.getWorkDriverList(query)
      if (result.data.length) {
        this.driverList = result.data.filter(item => {
          return (item.Area === this.WXInfo.area) && (Number(item.CarSeat) > item.passengers.length)
        })
      } else {
        this.driverList = []
        this.$toast(result.message)
      }
    },
    // 乘客确认拼车
    async onBoard () {
      let data = {
        ParentsId: this.travelId,
        UserId: this.form.UserId,
        DriverId: this.form.DriverId,
        Distance: this.form.Distance,
        Way: this.form.Way,
        LngLat: this.form.LngLat,
        DateTime: this.date,
        Status: '已拼车'
      }
      let query = {
        Model: 'workpassenger',
        ParentsId: this.travelId,
        UserId: this.form.UserId,
        DateTime: this.date
      }
      const result = await this.postUpDataOrCreate(query, data)
      if (result.success) {
        this.havingTravel = true
        this.passengerTravelStatus = '已拼车'
        this.sendMessage('passengerBoard', this.form.DriverId, this.form)
        this.$dialog.alert({ title: '提示', message: '已确认拼车，请在指定时间和点上车。' })
      }
    },
    // 乘客取消行程
    passengerCancle () {
      this.$dialog.confirm({
        title: '提示',
        message: '是否取消行程？',
      })
        .then(async () => {
          this.sendMessage('passengerCancle', this.form.DriverId, this.form)
          const result = await this.deleteWorkPassenger(this.travelId)
          this.$toast(result.message)
          if (result.success) {
            this.havingTravel = false
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    // 乘客确认上车
    async passengerConfirm() {
      let nowDate = this.$moment().format('YYYY-MM-DD')
      let nowTime = this.$moment().format('HH:mm')
      if (nowDate === this.date) {
        if ((nowTime >= '06:00') && (nowTime <= '08:35')) {
          let query = {
            Model: 'workpassenger',
            ParentsId: this.travelId,
            UserId: this.form.UserId,
            DateTime: this.date
          }
          let data = {
            ParentsId: this.travelId,
            UserId: this.form.UserId,
            DriverId: this.form.DriverId,
            Distance: this.form.Distance,
            Way: this.form.Way,
            LngLat: this.form.LngLat,
            DateTime: this.date,
            Status: '已上车'
          }
          const result = await this.postUpDataOrCreate(query, data)
          if (result.success) {
            this.passengerTravelStatus = '已上车'
            this.sendMessage('passengerBoard', this.form.DriverId, this.form)
            this.$dialog.alert({
              title: '提示',
              message: '今日拼车已完成，等待司机下次预约拼车~'
            })
            this.passengerBtn = true
          } else {
            this.$toast(result.message)
          }
        } else {
          this.$dialog.alert({
          title: '提示',
          message: '当前 '+ this.$moment().format('HH:mm') +' 时间，需在 8:35 前确认上车，否则无法确认上车。'
        })
        }
      } else {
        this.$dialog.alert({
          title: '提示',
          message: '当前 '+ this.$moment().format('YYYY-MM-DD') +' 日期，不是发车日期，无法确认上车。'
        })
      }
    },
    // 清除早拼注册数据后回到入口重新申请
    reregister () {
      this.$dialog.confirm({
        title: '提示',
        message: '将清除早班拼车注册信息，是否继续？'
      })
        .then(async () => {
          const uid = this.form.UserId || this.WXInfo.userid
          const result = await this.$request({
            url: this.$api.deleteWorkUserRegistration,
            method: 'DELETE',
            params: { UserId: uid }
          })
          if (result.success) {
            this.$toast('已清除，请重新注册')
            this.$router.replace('/work/login')
          } else {
            this.$toast(result.message || '操作失败')
          }
        })
        .catch(() => {})
    },
    // 乘客取消绑定司机
    cancleBind () {
      this.$dialog.confirm({
        title: '提示',
        message: '是否取消绑定？解绑后需重新选择司机才能拼车。审核1-3工作日。',
      })
        .then(async () => {
          let query = {
            Model: 'workuser',
            UserId: this.form.UserId
          }
          let data = {
            DepartTime: '',
            Way: '',
            LngLat: [],
            Distance: 0,
            DriverId: '',
            Effictive: false,
            Status: false
          }
          const result = await this.postUpDataOrCreate(query, data)
          if (result.success) {
            this.sendMessage('passengerCancleBind', this.form.DriverId, this.form)
            this.$toast('已解除绑定')
            this.getData()
          } else{
            this.$toast(result.message)
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    sendMessage(type, userid, value) {
      let message = ''
      if (type === 'driverMake') { // 司机发起预约拼车，给所有乘客发生消息
        message = '消息通知：' +
        '\n\n日期：' + this.date +
        '\n司机：' + value.DriverName +
        '\n上车时间：' + value.DepartTime +
        '\n上车地点：' + value.Way + 
        '\n\n司机已发起早班拼车，请确认拼车。\n\n' +
        '<a href="https://pinche.jafron.com/work/index">我要拼车</a>'
      } else if (type === 'driverConfirm') { // 司机确认发车，给所有乘客发生消息
        message = '消息通知：' +
        '\n\n您预约'+value.DateTime+'的早班拼车，司机已发车。若您未上车本次行程将自动取消。'
      } else if (type === 'passengerCancle') { // 乘客取消拼车，给司机发生消息
        message = '消息通知：' +
        '\n\n日期：' + this.date +
        '\n乘客：' + value.Name +
        '\n\n请注意，乘客已取消您的早班拼车。'
      } else if (type === 'passengerBoard') { // 乘客确认拼车，给司机发生消息
        message = '消息通知：' +
        '\n\n日期：' + this.date +
        '\n乘客：' + value.Name +
        '\n上车时间：' + value.DepartTime +
        '\n上车地点：' + value.Way + 
        '\n\n乘客已确认拼车，请在约定时间接上乘客。'
      } else if (type === 'passengerCancleBind') { // 乘客取消绑定，给司机发生消息
        message = '消息通知：' +
        '\n\n时间：' + this.$moment(new Date()).format('YYYY-MM-DD HH:mm') +
        '\n乘客：' + value.Name +
        '\n\n请注意，乘客已取消与您的绑定关系。'
      }
      this.postSendMessage(userid, message)
    },
    goTo (type, id) {
      if (type === 'bind') {
        this.$router.push('/work/bind?id=' + id)
      } else {
        this.$router.push('/work/audit')
      }
    },
    onCalendarSelect (data) {
      if (this.$moment(data).format('MM-DD') === this.$moment(new Date()).format('MM-DD') && this.$moment(new Date()).format('HH:mm') >= '08:25') {
        this.$toast('当前日期已过发最晚发车时间，请选择明日时间')
      } else {
        this.date = this.$moment(data).format('YYYY-MM-DD')
        this.week = this.$moment(data).format('dddd')
        this.showTime = true
      }
    },
    onTime (time) {
      this.time = time
      this.showTime = false
      this.showDate = false
    },
    findPassenger (arr) {
      let data = arr.find(item => {
        return item.UserId === this.form.UserId
      })
      this.passengerTravelStatus = data ? data.Status : null
    },
    // 乘客获取行程信息
    async getTravel(id) {
      const result = await this.$request({
        url: this.$api.getWorkTravel,
        method: 'GET',
        params: {
          UserId: id,
          Status: '已发布'
        }
      })
      if (result.data.length) {
        let data = result.data[0]
        await this.findPassenger(data.passenger)
        this.travelId = data._id
        this.date = data.DateTime
        this.week = this.$moment(data.DateTime).format('dddd')
        this.passengerBtnText = '确认拼车'
        this.havingTravel = true
      } else {
        this.passengerBtnText = '司机未发拼车'
        this.passengerBtn = true
      }
    },
    // 获取司机拼车行程
    async getWorkTravelApi(id) {
      const result = await this.$request({
        url: this.$api.getWorkTravel,
        method: 'GET',
        params: {
          UserId: id,
          Status: '已发布'
        }
      })
      if (result.data.length) {
        let data = result.data[0]
        this.travelId = data._id
        this.time = data.DepartTime
        this.date = data.DateTime
        this.week = this.$moment(data.DateTime).format('dddd')
        this.driverBtn = true
        // 绑定乘客的行程状态获取
        if (data.passenger.length){
          this.boardPerson = data.passenger
          this.refreshPassengerStatus(data.passenger)
        }
      } else {
        this.driverBtn = false
      }
    },
    // 查询用户基础数据
    async getUserInfo() {
      const result = await this.$request({
        url: this.$api.getWorkUserInfo,
        method: 'GET',
        params: {
          UserId: this.form.UserId
        }
      })
      if (result.data) {
        let data = result.data
        this.form = data
        if (!this.form.Name && this.WXInfo.name) {
          this.form.Name = this.WXInfo.name
        }
      } else {
        let role = this.$route.query.workrole
        if (role) {
          if (role === 'driver') {
            this.$router.push('/work/login')
          }
        } else {
          this.$router.push('/work/login')
        }

      }
    },
    // 获取已绑定的乘客列表
    getPassengerList() {
      return this.$request({
        url: this.$api.getPassengerListByDriverId,
        method: 'GET',
        params: {
          DriverId: this.form.UserId,
          Effictive: true,
          Status: true,
          Work: true
        }
      })
    },
    // 获取审核通过司机列表
    getWorkDriverList(data) {
      return this.$request({
        url: this.$api.getWorkDriverList,
        method: 'GET',
        params: data
      })
    },
    // 司机获取乘客申请绑定数据
    async getNeedBindData() {
      const result = await this.$request({
        url: this.$api.getPassengerListByDriverId,
        method: 'GET',
        params: {
          DriverId: this.form.UserId,
          Effictive: false,
          Work: true
        }
      })
      if (result.data.length > 0) {
        this.needBind = true
      }
    },
    // 获取早班乘客数据
    getWorkTravelFromPassenger(data) {
      return this.$request({
        url: this.$api.getWorkTravelFromPassenger,
        method: 'GET',
        params: data
      })
    },
    postWorkTravel (data) {
      return this.$request({
        url: this.$api.postWorkTravel,
        method: 'POST',
        params: {
          UserId: this.form.UserId,
          DateTime: this.date
        },
        data
      })
    },
    postUpDataOrCreate (query, data) {
      return this.$request({
        url: this.$api.postUpDataOrCreateApi,
        method: 'POST',
        params: query,
        data
      })
    },
    deleteTravel (id) {
      return this.$request({
        url: this.$api.deleteTravel,
        method: 'DELETE',
        params: {
          ParentsId: id
        }
      })
    },
    deleteWorkPassenger (id) {
      return this.$request({
        url: this.$api.deleteWorkPassengerApi,
        method: 'DELETE',
        params: {
          ParentsId: id,
          UserId: this.form.UserId
        }
      })
    },
    async postSendMessage(userid, message) {
      const result = await this.$request({
        url: this.$api.postSendMessageWX,
        method: 'POST',
        data: {
          'touser': userid,
          'msgtype': 'text',
          'agentid': this.$agentid,
          'text': { 'content': message }
        }
      })
      if (!result.success) {
        this.$toast(result.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    background-color: #F5F5F5;
  }
  .top-title {
    background-color: #FEB013;
    height: 100px;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .top-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
    flex-shrink: 0;
  }
  .title-text {
    color: #FFF5E4;
    font-size: 18px;
    text-shadow: 0px 4px 4px #FF9E04;
    font-weight: 600;
    padding-left: 12px;
  }
  .card {
    margin-bottom: 12px;
    background-color: #FFFFFF;
    padding: 10px 12px;
    border-radius: 4px;
  }
  .cell-flex {
    display: flex;
    align-items: center;
  }
  .cell-flex-center {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .card-msg {
    background-color: rgba(254, 176, 19, 0.1);
    font-size: 12px;
    padding: 5px 6px;
    border-radius: 4px;
    color: #7B5200;
    margin-left: 8px;
  }
  .driver-card {
    background-color: #F9F9F9;
    border-radius: 4px;
    font-size: 13px;
    margin-bottom: 8px;
  }
  .driver-time {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #D2D2D2;
    justify-content: space-between;
    padding-bottom: 12px;
  }
  .driver-way {
    display: flex;
    padding: 8px 0;
  }
  .driver-text {
    color: #F22222;
    font-size: 13px;
    text-align: center;
    margin-top: 8px;
  }
  .driver-list {
    background-color: #FFFFFF;
    margin-bottom: 8px;
    font-size: 14px;
    border-radius: 4px;
  }
  .driver-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
  }
  .driver-bottom {
    padding: 12px;
    border-top: 1px solid #D2D2D2;
  }
  .passenger {
    background-color: #FFFFFF;
    padding: 8px 8px;
    margin: 8px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    font-size: 15px;
  }
  .passenger-way {
    display: flex;
  }
  .calendar-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /deep/ .van-calendar__footer {
        box-shadow: 0 2px 10px rgba(125,126,128,.16);
  }
  /deep/ .van-search {
    padding: 10px 0;
  }
  /deep/ .van-search__content {
    background-color: #FFFFFF;
  }
  .driverlist-way {
    background-color: #FFFFFF;
    padding: 12px;
  }
  /deep/ .driver-info .van-button {
    height: 40px;
  }
  /deep/ .top-title .van-button {
    border-color: #FFFFFF;
    color: #FFFFFF;
    background: transparent;
    padding: 0 10px;
    min-width: auto;
  }
  .passenger-status {
    margin-left: 8px;
    color: #FFFFFF;
    border-radius: 25px;
    font-size: 12px;
    padding: 0 12px;
  } 
</style>
